import { useEffect, useRef, type RefObject } from 'react'

export function useOnClickOutside<T extends HTMLElement = HTMLElement>(
	ref: RefObject<T>,
	handler: (event: MouseEvent) => void,
	enabled = true,
): void {
	const listener = useRef<typeof handler>()
	listener.current = handler

	useEffect(() => {
		if (!enabled) return

		const handler = (event: MouseEvent) => {
			if (!listener.current) return
			const target = event.target as Node
			if (!target?.isConnected) return

			const isOutside = !ref.current?.contains(target)
			if (isOutside) {
				listener.current(event)
			}
		}

		window.addEventListener('mousedown', handler)

		return () => {
			window.removeEventListener('mousedown', handler)
		}
	}, [enabled])
}
